import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardSettingsRoutes = [
	{
		key: "reward-global-channels",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/global-channels`,
		component: React.lazy(() => import("views/reward-views/settings/global-configs/pages/GlobalChannelList")),
	},
	{
		key: "reward-global-channel",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/global-channel/:id`,
		component: React.lazy(() => import("views/reward-views/settings/global-configs/pages/ChannelBase")),
	},
	{
		key: "reward-global-channel-new",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/global-channel/new`,
		component: React.lazy(() => import("views/reward-views/settings/global-configs/pages/ChannelBase")),
	},
	{
		key: "reward-sub-channel-new",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/global-channel/:channel/sub-channel/new`,
		component: React.lazy(() => import("views/reward-views/settings/global-configs/pages/SubChannelInfo")),
	},
	{
		key: "reward-sub-channel",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/global-channel/:channel/sub-channel/:subchannel`,
		component: React.lazy(() => import("views/reward-views/settings/global-configs/pages/SubChannelInfo")),
	},
	{
		key: "reward-channel-config",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/tier-configs`,
		component: React.lazy(() => import("views/reward-views/settings/tier-configs/pages/TierConfigs")),
	},
	{
		key: "reward-media-library",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/media/library`,
		component: React.lazy(() => import("views/reward-views/settings/media-library/pages/MediaList")),
	},
	{
		key: "reward-extra-cashback",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/extra-cashback`,
		component: React.lazy(() => import("views/reward-views/catalog/volume-cashback/pages/ExtraCashback")),
	},
];
